// A small "are you sure" bottom sheet for the destructive Me actions (delete account, restart, forget everything).
import type { ComponentChildren } from 'preact';
import { BottomSheet, PrimaryButton, TextButton } from '../../components';
import s from './me.module.css';

export function ConfirmSheet({ open, title, body, confirm, onConfirm, onClose, busy, danger = true, head }: {
  open: boolean; title: string; body: string; confirm: string; onConfirm: () => void; onClose: () => void;
  busy?: boolean; danger?: boolean; head?: ComponentChildren;
}) {
  return (
    <BottomSheet open={open} onClose={onClose} label={title}>
      {head || <p class={s.sheetT}>{title}</p>}
      <p class={s.sheetSub} style={{ marginTop: head ? 0 : -6 }}>{body}</p>
      <PrimaryButton h={56} class={danger ? s.danger : undefined} busy={busy} data-cta="confirm" onClick={onConfirm}>{confirm}</PrimaryButton>
      <TextButton onClick={onClose}>Cancel</TextButton>
    </BottomSheet>
  );
}
